export const categories = [
  {
    slug: 'asmr-audio',
    name: 'ASMR音频',
    description: '精选全球最优质的ASMR音频内容，从耳语、敲击到翻页声，每一种声音都精心挑选，给你最纯粹的听觉满足感。',
    icon: 'ri-headphone-line',
    imageSeq: 'cat-asmr-01',
    color: 'primary',
  },
  {
    slug: 'immersive-soundscape',
    name: '沉浸式声景',
    description: '带你穿越到雨林、海边、咖啡馆，用声音构建身临其境的虚拟空间，释放压力、提升专注力。',
    icon: 'ri-landscape-line',
    imageSeq: 'cat-soundscape-01',
    color: 'accent',
  },
  {
    slug: 'earphone-recommend',
    name: '耳机推荐',
    description: '专业评测市面上最适合ASMR体验的高品质耳机，从入门到旗舰，帮你找到那副让耳朵上瘾的神器。',
    icon: 'ri-headphone-fill',
    imageSeq: 'cat-earphone-01',
    color: 'secondary',
  },
  {
    slug: 'ersao-tips',
    name: '耳骚技巧',
    description: '分享触发ASMR反应的技巧与方法，从呼吸节奏到声音层次，解锁你的听觉敏感度。',
    icon: 'ri-lightbulb-line',
    imageSeq: 'cat-tips-01',
    color: 'primary',
  },
  {
    slug: 'sound-healing',
    name: '声音疗愈',
    description: '探索声音对身心的疗愈力量，白噪音、颂钵、自然频率，用声音安抚焦虑、改善睡眠。',
    icon: 'ri-heart-pulse-line',
    imageSeq: 'cat-healing-01',
    color: 'accent',
  },
];

export const articles = [
  {
    slug: 'asmr-beginner-guide',
    title: 'ASMR入门指南：从零开始感受颅内高潮',
    excerpt: '什么是ASMR？为什么有些人听了会起鸡皮疙瘩？这份入门指南带你全面了解ASMR的科学原理和最佳入门方式。',
    content: `<p>ASMR（Autonomous Sensory Meridian Response），中文译为"自发性知觉经络反应"，是一种令人愉悦的、从头皮开始向下蔓延的酥麻感。这种感觉通常由特定的听觉或视觉刺激触发，被爱好者们称为"颅内高潮"。</p>
    <h3>什么是ASMR？</h3>
    <p>简单来说，ASMR是一种身体对特定刺激产生的生理反应。当听到某些声音（如轻声细语、纸张翻动、敲击声）时，有些人会感到头皮发麻，一股舒适的暖流从头顶向下蔓延，带来深度的放松和愉悦感。</p>
    <p>这种反应并非人人都有，研究表明大约只有20%-40%的人能够体验到ASMR。但即使你暂时感受不到，也不用着急——很多人通过持续接触，敏感度会逐渐提升。</p>
    <h3>最常见的ASMR触发音</h3>
    <p><strong>轻声耳语：</strong>最经典的ASMR触发方式，柔和的人声在耳边低语，能迅速引发放松反应。</p>
    <p><strong>敲击声：</strong>指甲或工具在木头、玻璃、塑料等材质上的有节奏敲击，清脆而治愈。</p>
    <p><strong>翻页声：</strong>纸张翻动的沙沙声，复古而有质感，让人想起图书馆的午后。</p>
    <p><strong>水流声：</strong>溪流、雨滴、海浪的声音，模拟自然环境中的白噪音。</p>
    <p><strong>咀嚼声：</strong>虽然有些争议，但吃脆物时发出的声音对很多人来说极具触发力。</p>
    <h3>如何开始你的ASMR之旅</h3>
    <p>首先，找一个安静的环境，戴上品质较好的耳机。然后选择一种你感兴趣的声音类型，闭上眼睛，专注于声音的细节。不要给自己太大压力——ASMR的核心是放松，越刻意追求反而越难感受到。</p>`,
    category: 'asmr-audio',
    imageSeq: 'article-asmr-guide',
    author: '耳骚编辑部',
    date: '2026-07-28',
    readTime: '8分钟',
    tags: ['ASMR入门', '新手教程', '触发音'],
    featured: true,
  },
  {
    slug: 'top-asmr-headphones-2026',
    title: '2026年最适合ASMR的耳机Top 10推荐',
    excerpt: '从百元到旗舰，我们实测了市面上30款耳机，选出最适合ASMR聆听的10款，每一款都能让你的耳朵欲罢不能。',
    content: `<p>一副好耳机是ASMR体验的灵魂。普通的耳机可能会丢失声音中的细节层次，而专业级的耳机则能让你仿佛置身声音现场，每一丝耳语、每一次敲击都历历在耳。</p>
    <h3>为什么ASMR需要专门的耳机？</h3>
    <p>ASMR音频通常包含大量细微的声音细节——呼吸声、衣物的摩擦声、指尖轻触的声响。普通耳机在解析力不足时，这些细节会糊成一团，失去触发效果。而好的耳机能够精准还原每一条声波，让ASMR的"酥麻感"发挥到极致。</p>
    <h3>选购要点</h3>
    <p><strong>解析力：</strong>高频细节的还原能力是ASMR耳机的核心指标。</p>
    <p><strong>声场表现：</strong>宽广的声场能营造出空间感和距离感，让"耳边低语"效果更真实。</p>
    <p><strong>佩戴舒适度：</strong>ASMR通常需要长时间聆听，耳机不能给耳朵带来压迫感。</p>
    <p><strong>降噪能力：</strong>环境噪音是ASMR的大敌，主动降噪功能能让你完全沉浸在声音世界。</p>
    <h3>Top 10 推荐榜单</h3>
    <p>经过一个月的实测，我们从30款耳机中选出了以下10款：从入门级的HiFiMan Sundara到旗舰级的Sennheiser HD 800S，每款都有详细的音质分析和ASMR适配度评分。</p>`,
    category: 'earphone-recommend',
    imageSeq: 'article-headphones',
    author: '音频评测组',
    date: '2026-08-01',
    readTime: '12分钟',
    tags: ['耳机评测', 'ASMR设备', '2026推荐'],
    featured: true,
  },
  {
    slug: 'rain-soundscape-guide',
    title: '雨声疗愈：打造专属沉浸式雨景声场',
    excerpt: '雨声是最受欢迎的ASMR音效之一。本文将教你如何利用不同的雨声类型，构建属于自己的放松空间。',
    content: `<p>雨声是大自然赠予我们最温柔的ASMR。从淅淅沥沥的小雨到滂沱大雨，每一种雨声都有它独特的疗愈力量。科学研究表明，雨声中的粉红噪音能有效降低大脑中的β波活动，帮助人们进入放松状态。</p>
    <h3>不同雨声的疗愈效果</h3>
    <p><strong>细雨敲窗：</strong>轻柔而有节奏，最适合作为工作背景音，提升专注力。</p>
    <p><strong>林中雨声：</strong>雨水打在树叶上的声音层次丰富，白噪音效果最佳，适合助眠。</p>
    <p><strong>屋顶雨声：</strong>低沉而有力量感，能有效掩盖城市噪音，营造安全感。</p>
    <p><strong>雷雨交加：</strong>远方的雷声配合雨声，戏剧化的对比让人感到"屋内的安全"，极具治愈效果。</p>
    <h3>如何搭建你的雨声场景</h3>
    <p>推荐使用高品质的开放式耳机或音响系统，选择Binaural（双耳）录制的雨声音频——这种录音技术能模拟人耳真实的听觉感受，让声音充满空间感和方位感。</p>`,
    category: 'immersive-soundscape',
    imageSeq: 'article-rain',
    author: '声景设计师·林雨',
    date: '2026-07-25',
    readTime: '6分钟',
    tags: ['雨声', '沉浸式声景', '放松'],
    featured: true,
  },
  {
    slug: 'trigger-sensitivity-training',
    title: '耳骚敏感度训练：7天提升你的ASMR触发感',
    excerpt: '感受不到ASMR？别急，通过科学的敏感度训练，你也能体验到颅内高潮的极致快感。',
    content: `<p>很多人抱怨自己"感受不到ASMR"，这其实很正常。ASMR敏感度就像肌肉一样，是可以通过训练来提升的。我们设计了一套7天的训练计划，帮助你逐步打开听觉的敏感通道。</p>
    <h3>训练核心原理</h3>
    <p>ASMR反应的强弱与大脑对特定频率声音的处理能力有关。通过系统性的暴露训练，大脑会逐渐学会将特定声音与"安全、放松"联系起来，从而触发愉悦的生理反应。</p>
    <h3>7天训练计划</h3>
    <p><strong>Day 1-2：环境准备期</strong>——建立固定的聆听时间和空间，排除外界干扰，让大脑进入"接收模式"。</p>
    <p><strong>Day 3-4：声音探索期</strong>——尝试不同类型的触发音，记录自己的反应强度，找到最适合你的声音类型。</p>
    <p><strong>Day 5-6：深度沉浸期</strong>——在最佳触发音的基础上，加入视觉触发（如慢速手势视频），多感官协同激活。</p>
    <p><strong>Day 7：自由创作期</strong>——尝试自己录制简单的触发音，从"被动接收"到"主动创造"，完成听觉觉醒的闭环。</p>`,
    category: 'ersao-tips',
    imageSeq: 'article-training',
    author: '听觉训练师·陈耳',
    date: '2026-07-20',
    readTime: '10分钟',
    tags: ['敏感度训练', '耳骚技巧', '7天计划'],
    featured: false,
  },
  {
    slug: 'white-noise-sleep-guide',
    title: '白噪音助眠完全指南：从科学原理到最佳实践',
    excerpt: '睡不着？白噪音可能是你一直在找的答案。了解白噪音的助眠原理，以及如何选择最适合你的声音类型。',
    content: `<p>白噪音是声音疗愈领域中最基础也最有效的工具。它听起来像没有调频的收音机发出的"沙沙"声，但正是这种看似单调的声音，却拥有神奇的助眠力量。</p>
    <h3>白噪音为什么能助眠？</h3>
    <p>白噪音包含了人耳可听范围内所有频率的声音，且每个频率的能量相等。这种"声音墙"能有效掩盖环境中的突发噪音——比如楼上的脚步声、窗外的汽车声——让大脑不再被这些突然的声音变化惊醒。</p>
    <h3>白噪音 vs 粉红噪音 vs 棕色噪音</h3>
    <p><strong>白噪音：</strong>所有频率能量均等，听起来像电视雪花声，高频稍多。</p>
    <p><strong>粉红噪音：</strong>高频能量递减，听起来比白噪音更"柔和"，更接近自然界的雨声、风声。</p>
    <p><strong>棕色噪音：</strong>高频能量大幅减少，声音更深沉，像远处的瀑布声或雷声，对焦虑情绪有特殊的安抚效果。</p>`,
    category: 'sound-healing',
    imageSeq: 'article-white-noise',
    author: '睡眠科学研究者·周眠',
    date: '2026-07-15',
    readTime: '7分钟',
    tags: ['白噪音', '睡眠', '声音疗愈'],
    featured: false,
  },
  {
    slug: 'binaural-recording-secrets',
    title: '双耳录音技术揭秘：为什么ASMR要听Binaural音频',
    excerpt: '双耳录音（Binaural Recording）是高质量ASMR内容的核心技术。了解它如何模拟真实听感，让你获得身临其境的体验。',
    content: `<p>如果你听过真正高质量的ASMR音频，你一定注意到那种奇妙的空间感——声音仿佛真的在你左耳边移动，然后缓缓滑到右耳后方。这就是双耳录音技术的魔力。</p>
    <h3>什么是双耳录音？</h3>
    <p>双耳录音使用一个仿真人头模型（Dummy Head），在模型的耳道位置放置两个高灵敏度麦克风。这样录出来的声音完美复现了人耳在真实环境中的听觉感受——包括声音到达两只耳朵的时间差（ITD）和强度差（ILD），以及耳廓对声音的滤波效果（HRTF）。</p>
    <h3>为什么它对ASMR至关重要</h3>
    <p>ASMR的核心是"亲密感"和"临场感"。普通立体声录音只能区分左右，而双耳录音能还原声音在三维空间中的位置——上下、前后、远近。当你用耳机听双耳录音的ASMR时，大脑会被"欺骗"，以为声源真的在你身边移动。这种错觉正是触发强烈ASMR反应的关键。</p>`,
    category: 'asmr-audio',
    imageSeq: 'article-binaural',
    author: '音频工程师·王声',
    date: '2026-07-10',
    readTime: '9分钟',
    tags: ['双耳录音', 'ASMR技术', '音频科普'],
    featured: false,
  },
  {
    slug: 'asmr-youtubers-top10',
    title: '全球十大ASMR创作者推荐：耳朵从未如此满足',
    excerpt: '从韩国到美国，这些ASMR创作者用声音征服了全球数亿听众。来看看谁是真正的"耳骚之王"。',
    content: `<p>ASMR文化的兴起离不开YouTube上那些才华横溢的创作者。他们用麦克风和创意，为全球听众打开了一扇通往极致听觉享受的大门。我们整理了全球十大最具影响力的ASMR创作者，每一位都有自己独特的风格和魅力。</p>
    <h3>评选标准</h3>
    <p>我们的评选综合了频道订阅量、视频播放量、内容创新度、声音质量以及听众口碑五个维度。排名不分先后。</p>`,
    category: 'asmr-audio',
    imageSeq: 'article-youtubers',
    author: '耳骚编辑部',
    date: '2026-07-05',
    readTime: '15分钟',
    tags: ['ASMR创作者', 'YouTube', '推荐榜单'],
    featured: true,
  },
  {
    slug: 'open-back-vs-closed-back',
    title: '开放式 vs 封闭式：哪种耳机更适合ASMR？',
    excerpt: '开放式耳机声场宽广但漏音，封闭式耳机隔音好但声场窄。对于ASMR来说，哪种才是最佳选择？',
    content: `<p>选购ASMR耳机时，开放式和封闭式的选择可能是最让人纠结的问题。两者各有优劣，最终的答案取决于你的使用场景和个人偏好。</p>
    <h3>开放式耳机</h3>
    <p>开放式耳机的耳罩外侧有网孔，声音可以自由进出。这使得声场非常宽广自然，声音仿佛从外部空间传来，而非挤在脑袋里。对于ASMR来说，这种宽广的空间感能大大增强"临场感"——耳边低语的效果尤其出色。</p>
    <p>但开放式耳机不隔音，环境噪音会干扰ASMR的细腻细节；同时也会漏音，在公共场合使用会打扰他人。</p>
    <h3>封闭式耳机</h3>
    <p>封闭式耳机能有效隔绝外部噪音，让你完全沉浸在ASMR的世界中。对于需要降噪的环境（如办公室、通勤途中），封闭式是更好的选择。</p>
    <p>但封闭式耳机的声场通常不如开放式宽广，声音可能会显得"闷"一些，这对于需要空间感的ASMR内容是一个劣势。</p>`,
    category: 'earphone-recommend',
    imageSeq: 'article-open-closed',
    author: '音频评测组',
    date: '2026-06-28',
    readTime: '8分钟',
    tags: ['耳机对比', '开放式', '封闭式'],
    featured: false,
  },
  {
    slug: 'nature-soundscape-top5',
    title: '五大自然声景推荐：足不出户环游世界的声音旅行',
    excerpt: '从亚马逊雨林到冰岛冰川，这些自然声景音频能让你在办公室里感受地球最纯粹的声音。',
    content: `<p>自然声景是ASMR领域中最受欢迎的类型之一。不需要昂贵的机票，一副好耳机就能带你穿越到地球上最美妙的声学环境中。我们精选了五大最具沉浸感的自然声景。</p>
    <h3>1. 亚马逊雨林·清晨</h3>
    <p>数百种鸟类的鸣叫、远处猴子的吼声、树叶上的露水滴落——这是地球上生物多样性最丰富的声景之一。</p>
    <h3>2. 冰岛·冰川融水</h3>
    <p>冰块裂开时的清脆声响、融水在冰面上流动的细腻声音，纯净而空灵。</p>
    <h3>3. 日本·竹林风声</h3>
    <p>风吹过竹林的沙沙声，竹节相互碰撞的"咔嗒"声，充满禅意。</p>`,
    category: 'immersive-soundscape',
    imageSeq: 'article-nature',
    author: '声景设计师·林雨',
    date: '2026-06-20',
    readTime: '7分钟',
    tags: ['自然声景', '旅行', '沉浸式体验'],
    featured: false,
  },
  {
    slug: 'asmr-for-anxiety',
    title: '声音对抗焦虑：ASMR如何成为现代人的心灵解药',
    excerpt: '焦虑已成为现代社会的流行病。越来越多的研究表明，ASMR可能是缓解焦虑最简单有效的非药物手段之一。',
    content: `<p>在这个信息爆炸的时代，焦虑几乎成了每个人的日常伴侣。药物治疗虽然有效，但副作用和依赖性让人望而却步。ASMR作为非药物的放松手段，正在被越来越多的心理学研究者关注。</p>
    <h3>研究怎么说</h3>
    <p>2025年发表在《心理学前沿》上的一项研究显示，观看ASMR视频后，参与者的心率平均降低了5-8次/分钟，唾液皮质醇（压力激素）水平下降了约25%。这些数据与轻中度冥想练习的效果相当。</p>
    <h3>如何用ASMR对抗焦虑</h3>
    <p>建立每日ASMR时间：每天固定15-20分钟，戴上耳机，选择自己喜欢的触发音类型。坚持21天，你会明显感受到焦虑水平的下降。</p>`,
    category: 'sound-healing',
    imageSeq: 'article-anxiety',
    author: '心理咨询师·安心',
    date: '2026-06-15',
    readTime: '9分钟',
    tags: ['焦虑', '心理健康', '声音疗愈'],
    featured: true,
  },
  {
    slug: 'asmr-microphone-guide',
    title: 'ASMR录音麦克风选购指南：从百元到专业级',
    excerpt: '想自己录制ASMR内容？麦克风是第一步。我们整理了适合不同预算的ASMR录音麦克风推荐。',
    content: `<p>ASMR录音对麦克风的要求与普通录音不同——需要极高的灵敏度来捕捉细微的声音细节，同时还要有出色的本底噪声控制。这份指南涵盖了从入门到专业的全价位推荐。</p>`,
    category: 'ersao-tips',
    imageSeq: 'article-mic',
    author: '音频工程师·王声',
    date: '2026-06-08',
    readTime: '11分钟',
    tags: ['麦克风', '录音设备', 'ASMR制作'],
    featured: false,
  },
  {
    slug: 'midnight-asmr-playlist',
    title: '深夜耳骚歌单：10首让你耳朵上瘾的必听曲目',
    excerpt: '夜深人静时，耳朵最渴望什么声音？这份深夜专属ASMR歌单，每一首都经过精心挑选，陪你度过每一个不眠夜。',
    content: `<p>深夜是一天中听觉最敏感的时刻。灯光熄灭，世界安静下来，耳朵开始渴望那些白天被忽略的细微声响。这份歌单专门为深夜聆听设计，每一首都能带你进入声音的温柔乡。</p>`,
    category: 'asmr-audio',
    imageSeq: 'article-playlist',
    author: '耳骚编辑部',
    date: '2026-06-01',
    readTime: '6分钟',
    tags: ['歌单', '深夜', '推荐'],
    featured: false,
  },
];